import { GridRequest } from 'projects/app-core/src/models/gridRequest';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';

export enum LyfisPartnerProfilesSort {
  UPDATED_AT = 'updatedAt',
}

export enum LyfisPartnerProfilesFilter {
  ACTIVE = 'active',
  PARTNER_ID = 'partnerId',
}

export enum LyfisPartnerProfilesDateFilter {
  UPDATED_AT = 'updatedAt',
}

export interface LyfisPartnerProfilesGridRequest
  extends GridRequest<
    LyfisPartnerProfilesSort,
    LyfisPartnerProfilesFilter,
    string,
    LyfisPartnerProfilesDateFilter
  > {}

export interface LyfisPartnerProfilesFilterData {
  active?: boolean[];
  partnerId?: (string | null)[];
}

export interface LyfisPartnerProfileGridItem {
  id?: string;
  _id?: string;
  partnerId?: string | null;
  questionBlockIds: string[];
  active: boolean;
  enabledDiseases: string[];
  additionalFacts: Record<string, unknown>[];
  diseaseArtifacts: Array<{ diseaseId: string; compiledArtifactId: string }>;
  pdhBandsRules: string[];
  ghsBandsRules: string[];
  createdAt?: string;
  lastModifiedAt?: string;
}

export interface LyfisPartnerProfilesGridResponse
  extends GridResponse<LyfisPartnerProfilesFilterData | undefined, LyfisPartnerProfileGridItem> {}


